import React, {ReactNode} from "react";
import {DropdownMenu, DropdownMenuDots, styled} from "@reside/ui";
import {Tooltip} from "../../../tooltip";

/** Wraps the ⋯ trigger; `data-dashboard-card-stop` keeps `DashboardCell` admission click from firing on open/close. */
const MenuTriggerWrap = styled.span`
  display: inline-flex;
`;

/** Same hover fill as star icon; no pill border. Tight footprint around scaled dots. */
const DashboardCardMenuDots = styled(DropdownMenuDots)`
  border: none;
  background-color: transparent;
  transition: background-color 0.12s ease;
  padding: 2px 8px;
  border-radius: 12px;
  color: ${({theme}) => theme.color.gray150};

  /* Keep UI kit’s sub-pixel nudge; scale dots up slightly (StyledIcon only sets translate). */
  > i {
    transform: scale(1.15) translate(0.5px, 0.5px);
    transform-origin: center center;
  }

  &:hover,
  &:focus-visible {
    background-color: ${({theme}) => theme.color.borderLightGray};
  }
`;

type Props = Readonly<{
  tooltip?: string;
  testId?: string;
  children: ReactNode;
}>;

/** Single ⋯ trigger for dashboard admission cards (replaces split Edit + caret). */
export const AdmissionCardActionsMenu = ({
  tooltip = "Actions",
  testId,
  children,
}: Props) => (
  <DropdownMenu
    trigger={() => (
      <MenuTriggerWrap data-dashboard-card-stop="">
        <Tooltip content={tooltip}>
          <DashboardCardMenuDots testId={testId} />
        </Tooltip>
      </MenuTriggerWrap>
    )}
  >
    {children}
  </DropdownMenu>
);
